import { cn } from '@/platform/lib/utils';

const Container = ({ fluid = false, className, children, ...props }) => (
    <div
        className={cn(
            'mx-auto w-full px-4 sm:px-6 lg:px-8',
            !fluid && 'md:max-w-3xl lg:max-w-4xl xl:max-w-6xl',
            className
        )}
        {...props}
    >
        {children}
    </div>
);

export default Container;
